// LayoutMenuData.js
export const navItems = [
  {
    id: "views",
    title: "Views",
    navList: [
      {
        id: "campaigns",
        label: "Campaigns",
        icon: "ri-rocket-line",
        iconActive: "ri-rocket-fill",
        path: "/campaigns",
      },
      // {
      //   id: "rewards",
      //   label: "Rewards",
      //   icon: "ri-gift-line",
      //   iconActive: "ri-gift-fill",
      //   path: "/rewards",
      // },
      {
        id: "statements",
        label: "Statements",
        icon: "ri-file-3-line",
        iconActive: "ri-file-fill",
        path: "/statements",
      },
      {
        id: "members",
        label: "Members",
        icon: "ri-group-line",
        iconActive: "ri-group-fill",
        path: "/members",
      },
      // {
      //   id: "Exported-Requests",
      //   label: "Exported Requests",
      //   icon: "ri-file-3-line",
      //   iconActive: "ri-file-text-line",
      //   path: "/exported-requests",
      // },
      {
        id: "Profile",
        label: "Profile",
        icon: "bx bx-user-circle",
        iconActive: "bx bxs-user-circle",
        path: "/settings/profile",
      },
      // {
      //   id: "Settings",
      //   label: "Settings",
      //   icon: "ri-tools-fill",
      //   iconActive: "ri-tools-fill",
      //   path: "#",
      //   subItems: [
      //     {
      //       id: "Profile",
      //       label: "Profile",
      //       icon1: "bx bx-user-circle",
      //       iconActive1: "bx bxs-user-circle",
      //       path: "/settings/profile",
      //     },
      //     {
      //       id: "Log Out",
      //       label: "Log Out",
      //       icon1: "bx bx-power-off",
      //       iconActive1: "bx bx-power-off",
      //       path: "/login",
      //     },
      //   ],
      // },
    ],
  },
];
